import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { AWS_REDSHIFT } from "../../Constants"

function ZdqAwsRedshiftConnectorStatus() {
  return <ZdqConnectorStatus vendor={AWS_REDSHIFT}></ZdqConnectorStatus>
}

export default ZdqAwsRedshiftConnectorStatus